import React from 'react';
import Icon from 'components/AppIcon';

const SORT_OPTIONS = [
  { value: 'popular', label: 'Most Popular' },
  { value: 'newest', label: 'Newest First' },
  { value: 'price_asc', label: 'Price: Low to High' },
  { value: 'price_desc', label: 'Price: High to Low' },
  { value: 'rating', label: 'Top Rated' },
];

export default function SortBar({ sortBy, onSortChange, viewMode, onViewModeChange, searchQuery, onSearchChange }) {
  return (
    <div className="flex flex-col sm:flex-row gap-3 items-start sm:items-center justify-between w-full">
      {/* Search */}
      <div className="relative flex-1 max-w-xs w-full">
        <Icon name="Search" size={16} color="var(--color-muted-foreground)" className="absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none" />
        <input
          type="text"
          placeholder="Search products..."
          value={searchQuery}
          onChange={(e) => onSearchChange(e?.target?.value)}
          className="w-full pl-9 pr-4 py-2 rounded-md border font-caption text-sm focus:outline-none focus:ring-2"
          style={{
            background: 'var(--color-input)',
            borderColor: 'var(--color-border)',
            color: 'var(--color-foreground)',
            '--tw-ring-color': 'var(--color-ring)',
          }}
        />
      </div>
      <div className="flex items-center gap-3">
        {/* Sort */}
        <div className="flex items-center gap-2">
          <Icon name="ArrowUpDown" size={15} color="var(--color-muted-foreground)" />
          <select
            value={sortBy}
            onChange={(e) => onSortChange(e?.target?.value)}
            className="font-caption text-sm border rounded-md px-2 py-2 focus:outline-none"
            style={{
              background: 'var(--color-input)',
              borderColor: 'var(--color-border)',
              color: 'var(--color-foreground)',
            }}
          >
            {SORT_OPTIONS?.map(opt => (
              <option key={opt?.value} value={opt?.value}>{opt?.label}</option>
            ))}
          </select>
        </div>

        {/* View Toggle */}
        <div className="flex items-center border rounded-md overflow-hidden" style={{ borderColor: 'var(--color-border)' }}>
          <button
            onClick={() => onViewModeChange('grid')}
            className="p-2 transition-colors"
            style={{ background: viewMode === 'grid' ? 'var(--color-primary)' : 'var(--color-background)' }}
            aria-label="Grid view"
          >
            <Icon name="Grid3X3" size={15} color={viewMode === 'grid' ? '#FFFFFF' : 'var(--color-muted-foreground)'} />
          </button>
          <button
            onClick={() => onViewModeChange('list')}
            className="p-2 transition-colors"
            style={{ background: viewMode === 'list' ? 'var(--color-primary)' : 'var(--color-background)' }}
            aria-label="List view"
          >
            <Icon name="List" size={15} color={viewMode === 'list' ? '#FFFFFF' : 'var(--color-muted-foreground)'} />
          </button>
        </div>
      </div>
    </div>
  );
}